module.exports = __webpack_public_path__ + "img/logo.dd329e4f.png";